import { FC, Dispatch, SetStateAction } from 'react';
import { WbDrawer } from '@agilelab/plugin-wb-platform';
import { EditServiceAccountForm } from './EditServiceAccountForm';
import { Entity } from '@mainstage/catalog-model';

export type EditServiceAccountDrawerProps = {
  serviceAccount: Entity;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onEdited?: () => void;
};

export const EditServiceAccountDrawer: FC<EditServiceAccountDrawerProps> = ({
  serviceAccount,
  open,
  setOpen,
  onEdited,
}) => {
  return (
    <WbDrawer
      open={open}
      setOpen={setOpen}
      size={50}
      ModalProps={{ keepMounted: false }}
      title="Edit Service Account"
    >
      <EditServiceAccountForm
        serviceAccount={serviceAccount}
        onEdited={onEdited}
      />
    </WbDrawer>
  );
};
